import React, { useEffect, useRef } from "react";
import "./Testimonials.css";

const TESTIMONIALS = [
  {
    initials: "AR",
    name: "Arjun Rawal",
    role: "Software Engineer · Bangalore",
    text: "Placify Innovative truly stands out. Their personalised approach made my job search seamless — from resume enhancement to interview coaching, everything I needed to land a great role was right there.",
    rating: 5,
  },
  {
    initials: "PS",
    name: "Priya Sharma",
    role: "Product Manager · Mumbai",
    text: "I was struggling to find a role matching my skills. Placify connected me with the right opportunity quickly. Their team is professional, thorough, and genuinely invested in your success.",
    rating: 5,
  },
  {
    initials: "MK",
    name: "Meera Krishnan",
    role: "Data Analyst · Hyderabad",
    text: "The LinkedIn optimization was a game-changer. Within two weeks I had three recruiter inbounds. Highly recommend to anyone serious about accelerating their career growth rapidly.",
    rating: 5,
  },
];

const Testimonials = () => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.08 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="testimonials" id="testimonials" ref={ref}>
      <div className="testimonials__inner">
        <div className="testimonials__header reveal">
          <span className="eyebrow">Success Stories</span>
          <h2 className="testimonials__h2">Real People. Real Placements.</h2>
          <p className="testimonials__sub">
            Hear from professionals who transformed their careers with Placify Innovative.
          </p>
        </div>

        <div className="testimonials__grid">
          {TESTIMONIALS.map((t, i) => (
            <div
              className="testimonials__card glass glass-hover reveal"
              key={i}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <div className="testimonials__quote-mark">"</div>
              <div className="testimonials__stars">
                {"★".repeat(t.rating)}
              </div>
              <p className="testimonials__text">{t.text}</p>
              <div className="testimonials__author">
                <div className="testimonials__avatar">{t.initials}</div>
                <div>
                  <div className="testimonials__name">{t.name}</div>
                  <div className="testimonials__role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
